import "@/style/bannerDetail.scss"
import "@/style/inConstruction.scss"
import "@/utils/nav"
import "@/utils/tab.js"
import "@/utils/website.js"

function get(par) {
    const local_url = decodeURI(document.location.href)
    const getstr = local_url.substr(local_url.indexOf('?') + 1)
    const get = getstr.split('&')
    for (var i in get) {
        if (get[i].indexOf(par + '=') >= 0) {
            return get[i].replace(par + '=', '');
        }
    }
    return false;
}
const id = get('id')
const title = get('title')
$('.member-us').append(title)
let bgList = `<img class="bg-img" src="/static/images/bg-icon.jpg" />`
$('#bg-box').append(bgList)
const more = `<div class="more">加载更多</div>`
$('.content-box').append(more)

$.get(`/api/admin/official/exc/informationPageList/${id}?current=1&size=12`, function (data) {
    if (data.data.total === 0) {
        const div = `<div class="no-text">
                        <img src="/static/images/vindicate-icon.png">
                        <p>暂无内容</p>
                    </div>`
        $(".content-box").html(div);
    }
    const memberList = data.data.records
    var contentList = ''
    $.each(memberList, function (i, item) {
        const bg = '/static/images/bg-icon.jpg'
        if (memberList[i].subtitle === null) {
            memberList[i].subtitle = ""
        }
        if (memberList[i].coverUrl === "") {
            memberList[i].coverUrl = "/static/images/bg.png"
        }
        if (memberList[i].linkType === 0 || memberList[i].linkType === null || memberList[i].coverUrl === "") {
            contentList +=
                "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx=0' + '&id=' + memberList[i].id + '&nav=' + encodeURI(nav) + '&bg=' + bg + ">" +
                "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                '<div class="detail-title">' + memberList[i].title + '</div>' +
                '<div class="content-detail">' +
                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                '</div>' +
                "</a>"
            $(".content-list-box").html(contentList)
        } else {
            contentList +=
                "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl + ' target=_blank' + ">" +
                "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                '<div class="detail-title">' + memberList[i].title + '</div>' +
                '<div class="content-detail">' +
                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                '</div>' +
                "</a>"
            $(".content-list-box").html(contentList)
        }
    })

    if (data.data.size >= data.data.total) {
        $(".more").hide()
    } else {
        $(".more").show()
    }
});

$(document).ready(function () {
    let num = 12
    $(".more").click(function () {
        num += 12
        $.get(`/api/admin/official/exc/informationPageList/${id}?current=1&size=` + num, function (data) {
            const memberList = data.data.records
            var contentList = ''
            $.each(memberList, function (i, item) {
                const bg = '/static/images/bg-icon.jpg'
                if (memberList[i].subtitle === null) {
                    memberList[i].subtitle = ""
                }
                if (memberList[i].coverUrl === "") {
                    memberList[i].coverUrl = "/static/images/bg.png"
                }
                if (memberList[i].linkType === 0 || memberList[i].linkType === null) {
                    contentList +=
                        "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx=0' + '&id=' + memberList[i].id + '&nav=' + encodeURI(nav) + '&bg=' + bg + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                        '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                        '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                        "</a>"
                    $(".content-list-box").html(contentList)
                } else {
                    contentList +=
                        "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl + ' target=_blank' + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                        '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                        '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                        "</a>"
                    $(".content-list-box").html(contentList)
                }
            })
            if (data.data.size >= data.data.total) {
                $(".more").hide()
            }
        })
    })
})
